/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessDrawsParticipations.internal

import features.userBusinessDrawsParticipations.models.ParticipationsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.userBusinessDrawsParticipations.internal.UserBusinessDrawsParticipationsUseCase.Params

internal class UserBusinessDrawsParticipationsUseCase : AsyncUseCase<ParticipationsModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val userBusinessDrawsParticipationsService: UserBusinessDrawsParticipationsService = UserBusinessDrawsParticipationsServiceImpl()

    override suspend fun run(params: Params): Result<ParticipationsModel> {
        return userBusinessDrawsParticipationsService.getUserBusinessDrawsParticipations(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
